export class KeyValueModel{
  title: string='';
  pathUrl: string='';
}
